import Icons from '@olxbr/olx-icons'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import BoxShortInfo from '../../molecules/BoxShortInfo'
import Link from '../../atoms/Link'

const BoxWrapper = styled(View)`
  width: 100%;
  align-items: flex-start;
  text-align: left;
`

const CalloutTouchable = styled(Link)`
  display: flex;
  width: 100%;
  &:hover {
    background-color: #f6f6f6;
  }
`

const IconWrapper = styled(View)`
  display: flex;
  border-radius: 32px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
`

const Verification = ({ verified, title, subtitle, Icon, customExtraOptions }) => (
  <BoxWrapper>
    <BoxShortInfo
      title={title}
      subtitle={subtitle}
      icon={
        <IconWrapper backgroundColor={verified ? '#F1FCF6' : '#F6F6F6'}>
          <Icon color={verified ? '#8CE563' : '#999999'} size="18" />
        </IconWrapper>
      }
      extraOptions={
        customExtraOptions ||
        (verified ? (
          <Icons.System.Check color="#8CE563" />
        ) : (
          <Icons.System.ChevronRight color="#999999" />
        ))
      }
    />
  </BoxWrapper>
)

Verification.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  verified: PropTypes.bool.isRequired,
  customExtraOptions: PropTypes.element,
}

const VerificationWrapper = styled(View)`
  margin: 8px 0;
  width: 100%;
`

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children

const VerificationRenderer = ({ verifications }) => {
  const { pending, verified } = verifications.reduce(
    (acc, item) => {
      if (item.verified) {
        acc.verified.push(item)
      } else {
        acc.pending.push(item)
      }
      return acc
    },
    { pending: [], verified: [] }
  )

  return (
    <React.Fragment>
      {pending.map(({ onClick, title, ...verification }) => (
        <VerificationWrapper key={title}>
          <ConditionalWrapper
            condition={!verification.disabled}
            wrapper={children => <CalloutTouchable onClick={onClick}>{children}</CalloutTouchable>}
          >
            <Verification title={title} {...verification} />
          </ConditionalWrapper>
        </VerificationWrapper>
      ))}
      {verified.map(({ title, ...verification }) => (
        <VerificationWrapper key={title}>
          <Verification title={title} {...verification} />
        </VerificationWrapper>
      ))}
    </React.Fragment>
  )
}

VerificationRenderer.propTypes = {
  verifications: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      Icon: PropTypes.elementType.isRequired,
      verified: PropTypes.bool.isRequired,
      onClick: PropTypes.func.isRequired,
      customExtraOptions: PropTypes.element,
    })
  ),
}

export default VerificationRenderer
